import React from 'react';
import styles from './EmptyTable.module.css';

export const EmptyTable = () => (
    <li className={styles.empty}>
        Здесь пока ничего нет :(
    </li>
);
